<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content work-order-form-page procedure-form-page">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu *ngIf="isSiteContext" [site]="selectedSite"></app-site-tab-menu>
            <app-card-tabs *ngIf="!isSiteContext" [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <div class="card-body">
              <card-section-header title="Procedure Details" icon="fas fa-edit"></card-section-header>
              <h5 class="create-from-procedure-subtitle" *ngIf="createOrEdit === 'EDIT'">
                Edit Procedure: {{ procedureToEdit?.name || '' }}
              </h5>

              <form *ngIf="!saveInProgress" [formGroup]="form" (ngSubmit)="submit()">
                <ng-container *ngIf="!pageLoading; else formSkeleton">
                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Name/Code <span class="required-text">(required)</span></label>
                        <input type="text" class="form-control sl-input" formControlName="name" placeholder="Enter name or code..." maxlength="30" />
                        <div class="d-flex justify-content-end mt-1">
                          <small [class.text-danger]="(form.controls['name'].value || '').length === 30" [class.font-weight-bold]="(form.controls['name'].value || '').length === 30" [class.text-muted]="(form.controls['name'].value || '').length !== 30">
                            ({{ (form.controls['name'].value || '').length }}/30)
                          </small>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Revision <span class="required-text">(required)</span></label>
                        <input type="text" class="form-control sl-input" formControlName="revision" />
                      </div>
                    </div>
                  </div>

                  <div class="row form-row">
                    <div [class.col-md-12]="createOrEdit === 'EDIT'" [class.col-md-6]="createOrEdit !== 'EDIT'">
                      <div class="form-group">
                        <label>Description <span class="required-text">(required)</span></label>
                        <textarea class="form-control sl-textarea" formControlName="description" placeholder="Enter description..."></textarea>
                      </div>
                    </div>
                    <div class="col-md-6" *ngIf="assetCategories.length && createOrEdit !== 'EDIT'">
                      <div class="form-group">
                        <label>Asset Category <span class="required-text">(required)</span></label>
                        <p-dropdown
                          class="form-control sl-input"
                          formControlName="assetCategory"
                          [options]="assetCategories"
                          optionLabel="label"
                          placeholder="Select asset category..."
                          [style]="{ width: '100%' }"
                          filter="true">
                        </p-dropdown>
                      </div>
                    </div>
                  </div>

                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Minimum Work Party Size <span class="required-text">(required)</span></label>
                        <input type="number" value="1" class="form-control sl-input" formControlName="minPartySize" min="1" max="30" placeholder="Enter work party size..." />
                      </div>
                    </div>
                    <div class="col-md-6" *ngIf="siteFormsOptions.length && allowCompulsoryCheckOnSiteForm && createOrEdit !== 'EDIT'">
                      <div class="form-group">
                        <label>Select Compulsory Check-On Site Form</label>
                        <p-dropdown
                          class="form-control sl-input"
                          formControlName="siteFormCheckOn"
                          [options]="siteFormsOptions"
                          optionValue="value"
                          placeholder="Select site form..."
                          [style]="{ width: '100%' }"
                          filter="true">
                        </p-dropdown>
                      </div>
                    </div>
                  </div>

                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group form-group-checkbox preapproved-group">
                        <label for="preapproved">Pre-approved?</label>
                        <p-checkbox class="form-control" inputId="preapproved" formControlName="preapproved" binary="true"></p-checkbox>
                      </div>
                    </div>
                  </div>

                  <div class="row form-row" *ngIf="createOrEdit !== 'EDIT'">
                    <div class="col-md-6" *ngIf="siteFormsOptions.length && allowCompulsoryCheckOffSiteForm">
                      <div class="form-group">
                        <label>Select Compulsory Check-Off Site Form</label>
                        <p-dropdown
                          class="form-control sl-input"
                          formControlName="siteFormCheckOff"
                          [options]="siteFormsOptions"
                          optionValue="value"
                          placeholder="Select site form..."
                          [style]="{ width: '100%' }"
                          filter="true">
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group rams-group">
                        <label>Upload Procedure Documents</label>
                        <div class="rams-control">
                          <div class="rams-upload" (click)="procedureDocumentsInput.click()">
                            <span class="rams-placeholder" *ngIf="!selectedDocuments.length">Choose procedure documents...</span>
                            <span class="rams-placeholder" *ngIf="selectedDocuments.length">{{ selectedDocuments.length }} file(s) selected</span>
                            <i class="pi pi-upload"></i>
                          </div>
                        <input
                          #procedureDocumentsInput
                          type="file"
                            class="rams-file-input"
                            name="procedureDocumentsPage"
                            id="procedureDocumentsPage"
                            accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
                          (change)="onFileChange($event)"
                          multiple
                        />
                          <button type="button" class="btn btn-success btn-round rams-add-btn" (click)="procedureDocumentsInput.click()">Add</button>
                        </div>
                        <ng-container *ngIf="selectedDocuments.length">
                          <div class="procedure-document-list">
                            <div class="procedure-document-list-row" *ngFor="let file of selectedDocuments; let i = index">
                              <span>{{ file.name }}</span>
                              <div class="file-list-links">
                                <button
                                  type="button"
                                  class="btn btn-primary btn-link"
                                  (click)="openSelectedDocument(file)">
                                  <i class="fas fa-search"></i>
                                  View
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-link text-danger procedure-remove-link"
                                  (click)="removeSelectedDocument(i)">
                                  <i class="fas fa-times"></i>
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-template #formSkeleton>
                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                  </div>
                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field variant="textarea"></skeleton-loading-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                  </div>
                  <div class="row form-row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <skeleton-loading-field></skeleton-loading-field>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </form>

              <div *ngIf="saveInProgress" style="text-align: center;">
                <p-progressSpinner></p-progressSpinner>
              </div>
              <div *ngIf="!saveInProgress" class="work-order-form-actions">
                <button type="button" (click)="submit()" [disabled]="!form.valid || saveInProgress" class="btn btn-success btn-round work-order-submit">{{ submitLabel }}</button>
                <button type="button" (click)="cancel()" class="btn btn-link btn-link-cancel">
                  <i class="fas fa-times"></i>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
